<script setup>
defineOptions({ name: 'GameCategories' });

import { computed } from 'vue';
import { useCategoriesStore } from '../stores/categories/categoriesStore';

const categoriesStore = useCategoriesStore();

const categories = computed(() => categoriesStore.categories);
const selectedCategory = computed(() => categoriesStore.selectedCategory);
const isLoading = computed(() => categoriesStore.isLoading);

const handleCategoryClick = (categorySlug) => {
  categoriesStore.setSelectedCategory(categorySlug);
};

const handleImageError = (event) => {
  const img = event.target;
  img.style.display = 'none';
  console.warn(`Error cargando imagen: ${img.src}`);
};
</script>

<template>
  <nav v-if="!isLoading && categories.length > 0" class="games-nav">
    <button 
      v-for="category in categories" 
      :key="category.id"
      class="nav-button"
      :class="{ active: category.slug === selectedCategory }"
      @click="handleCategoryClick(category.slug)"
    >
      <div class="category-icon-wrapper">
        <img 
          v-if="category.image_url" 
          :src="category.image_url" 
          :alt="category.name"
          class="category-icon"
          @error="handleImageError"
          loading="lazy"
        />
      </div>
      <span class="category-name">{{ category.name }}</span>
    </button>
  </nav>
</template>
<style scoped>
@import '../assets/styles/main.css';
</style>